module.exports = __webpack_public_path__ + "static/zmigrod_main_3-763c699dd28d99c7ee177d92b00e8f4a.png";